export const PAYMENT_PROVIDER_MAP = {
  contraentrega: "CASH",
  wompi: "WOMPI",
  addi: "ADDI",
  bold: "BOLD",
  sistecredito: "SISTECREDITO",
  whatsapp: "WHATSAPP",
};
